// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@synd/XDL/Utilities/mergeWithCss";
import React, { FC, useState } from "react";

interface OwnProps {
    cases: string;
    extendedStyles?: CasesStyles;
}

type Props = OwnProps;

export interface CasesStyles {
    wrapper?: InjectableCss;
    casesHeadingAndText?: SmallHeadingAndTextStyles;
}

export const casesStyles: CasesStyles = {};

const ProductCases: FC<Props> = ({ cases, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(casesStyles, extendedStyles));

    if (!cases) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <SmallHeadingAndText
                heading={translate("Cases/Pallet")}
                text={cases}
                extendedStyles={styles.casesHeadingAndText}
            />
        </StyledWrapper>
    );
};

export default ProductCases;
